import { ComputedQuery, FiltersMap } from '../model';
import { CollectionState } from './CollectionState';
import { Order, QueryResultSimulation } from './QueryResultSimulation';

function getKey<T>(
  item: T,
  maybeKeyOfT: string | keyof T,
): T[keyof T] | undefined | null {
  return item[maybeKeyOfT as keyof T];
}

export interface QueryResultSimulationDefaultParams<T, F extends FiltersMap> {
  readonly collection: CollectionState<T, F>;
}
export class QueryResultSimulationDefault<T, F extends FiltersMap>
  implements QueryResultSimulation<T, F>
{
  readonly collection: CollectionState<T, F>;

  constructor(params: QueryResultSimulationDefaultParams<T, F>) {
    this.collection = params.collection;
  }

  orderBy = (computedQuery: ComputedQuery<F>): Order<T>[] => {
    const { sort } = computedQuery;

    return [...(sort ?? [])];
  };

  predicate = (computedQuery: ComputedQuery<F>) => {
    const { collection } = this;
    const { query, itemName } = collection;
    const { search, filters } = computedQuery;

    return (item: T) => {
      for (const [filterName, value] of Object.entries(filters)) {
        const filter = query.filters[filterName];

        if (filter == null) {
          return false;
        }

        const fieldValue = getKey(item, filterName);
        if (
          value != null &&
          fieldValue != null &&
          !filter.matches(fieldValue, value)
        ) {
          return false;
        }
      }

      if (search && !itemName(item).toLowerCase().includes(search)) {
        return false;
      }

      return true;
    };
  };
}
